export default __webpack_public_path__ + "static/media/6.27654805.jpeg";